import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export const LinkItems = [
  { name: "Faqs",
     link: "/faq" },
  { name: "About Us",  link: "/about" },
  { name: "Browse", link: "/browse" },
  

];

export const NavItem = ({ icon, children, link, ...rest }) => {

  return (
    <Box
      as={Link}
      to={link}
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
      
    >
      <Flex
        align="center"
        p="5"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
     
        fontWeight="bold"
        _hover={{
          bg: "dark.900",
          color: "secondary.500",
        }}
        {...rest}
      >
        {/* {icon && (
          <Icon
            mr="4"
            fontSize="16"
            color="dark.900"
            _groupHover={{
              color: "secondary.500",
            }}
            as={icon}
          />
        )} */}
        {children}
      </Flex>
    </Box>
  );
};


